import type { TranslationKey } from "./fr.js";

export {
    faMessages
};

/**
 * Persian interface translations.
 *
 * This catalog must contain exactly the same keys as the French reference
 * catalog. TypeScript enforces that contract through `TranslationKey`.
 */
const faMessages: Record<TranslationKey, string> = {
    "app.title": "فرانسوی با دینو",

    "common.back": "بازگشت",
    "common.continue": "ادامه",
    "common.loading": "در حال بارگذاری…",
    "common.soon": "به زودی",
    "common.retry": "دوباره",
    "common.finish": "پایان",
    "common.next": "بعدی",
    "common.nextQuestion": "سؤال بعدی",
    "common.words": "کلمه",
    "common.sections": "بخش",
    "common.all": "همه →",
    "common.excellent": "عالی بود!",
    "common.good": "خوب بود!",
    "common.moreEffort": "بیشتر تلاش کن!",
    "common.morePractice": "باید بیشتر تمرین کنی!",

    "error.notFound.title": "محتوا پیدا نشد",
    "error.unavailable.title": "محتوا موقتاً در دسترس نیست",
    "error.unavailable.body": "سرور آموزشی پاسخ نمی‌دهد. چند لحظه دیگر دوباره تلاش کنید.",

    "navbar.grammar": "گرامر",
    "navbar.vocabulary": "واژگان",
    "navbar.travel": "سفر",
    "navbar.search": "جستجو در سایت",
    "navbar.switchLanguage": "تغییر زبان به فرانسوی",
    "navbar.primaryNavigation": "پیمایش اصلی",
    "navbar.menu": "منو",
    "navbar.group.learning": "یادگیری",
    "navbar.group.discovery": "کشف",
    "navbar.group.services": "خدمات",
    "navbar.group.account": "فضای من",
    "navbar.gamesExercises": "بازی‌ها و تمرین‌ها",
    "navbar.daily": "جلسه امروز من",
    "navbar.placement": "آزمون تعیین سطح",
    "navbar.admin": "مدیریت محتوا",
    "placement.title": "آزمون تعیین سطح",
    "placement.return": "بازگشت به صفحه من",
    "navbar.review": "مرورهای من",
    "navbar.music": "موسیقی",
    "navbar.journal": "مجله",
    "navbar.shop": "فروشگاه",
    "navbar.archive": "آرشیو",
    "navbar.profile": "پروفایل",
    "navbar.soon": "به زودی",
    "navbar.unavailable": "به زودی در دسترس است",

    "footer.tagline": "فرانسوی، قدم‌به‌قدم.",
    "footer.navigationLabel": "اطلاعات درباره دینو",
    "footer.socialLabel": "دینو در شبکه‌های اجتماعی",
    "footer.about": "درباره ما",
    "footer.contact": "تماس",
    "footer.workWithUs": "همکاری با ما",
    "footer.dinoAssistant": "دینو و هوش مصنوعی محلی",

    "institutional.eyebrow": "فرانسوی با دینو",
    "institutional.about.title": "درباره ما",
    "institutional.about.introduction": "دینو با مسیرهای کوتاه، تدریجی و کاربردی به زبان‌آموزان کمک می‌کند فرانسوی تمرین کنند.",
    "institutional.about.missionTitle": "ماموریت ما",
    "institutional.about.missionBody": "یادگیری فرانسوی را با درس‌های ساختاریافته، واژگان کاربردی و تمرین منظم روشن‌تر و ساده‌تر کنیم.",
    "institutional.about.methodTitle": "روش ما",
    "institutional.about.methodBody": "محتوا بر اساس سطوح CEFR تنظیم شده و توضیح، مثال، تمرین و موقعیت‌های واقعی زندگی را به هم پیوند می‌دهد.",
    "institutional.about.audienceTitle": "برای چه کسانی؟",
    "institutional.about.audienceBody": "این تجربه برای همه زبان‌آموزان طراحی شده و همراهی دوزبانه آن به‌ویژه برای فارسی‌زبانان مفید است.",
    "institutional.about.privacyTitle": "پیشرفت شما روی همین دستگاه می‌ماند",
    "institutional.about.privacyBody": "سطح، پیشرفت و مرورهای شما در همین مرورگر ذخیره می‌شوند. اگر حساب بسازید، فقط ایمیل و پروفایل خصوصی شما همگام می‌شود و قوانین دسترسی شخصی از آن محافظت می‌کنند.",
    "institutional.contact.title": "تماس",
    "institutional.contact.introduction": "پرسش، اصلاح محتوایی یا مشکل فنی دارید؟ از کانال عمومی پروژه استفاده کنید تا درخواست قابل پیگیری باشد.",
    "institutional.contact.beforeTitle": "برای پاسخ‌گویی بهتر",
    "institutional.contact.itemContent": "برای اصلاح آموزشی، درس، سطح و بخش موردنظر را مشخص کنید.",
    "institutional.contact.itemBug": "برای خطای فنی، دستگاه، مرورگر و مراحل بازتولید مشکل را بنویسید.",
    "institutional.contact.itemAccessibility": "برای مشکل دسترس‌پذیری، اقدام مسدودشده و فناوری کمکی مورد استفاده را توضیح دهید.",
    "institutional.contact.action": "ثبت درخواست",
    "institutional.contact.actionMeta": "در مخزن عمومی دینو یک Issue بسازید تا زمینه و روند پاسخ حفظ شود.",
    "institutional.contact.publicNotice": "درخواست‌های GitHub عمومی هستند؛ اطلاعات شخصی یا محرمانه در آن‌ها منتشر نکنید.",
    "institutional.contact.socialTitle": "ما را دنبال کنید",
    "institutional.work.title": "همکاری با ما",
    "institutional.work.introduction": "دینو با مشارکت‌های هدفمندی رشد می‌کند که مستقیماً تجربه یادگیری را بهتر می‌کنند.",
    "institutional.work.contentTitle": "آموزش و محتوا",
    "institutional.work.contentBody": "بازبینی درس، بهبود ترجمه یا پیشنهاد تمرین فرانسوی-فارسی متناسب با سطح هدف.",
    "institutional.work.productTitle": "محصول و دسترس‌پذیری",
    "institutional.work.productBody": "شفاف‌تر کردن مسیر، آزمودن تجربه موبایل یا گزارش موانع کاربران فناوری‌های کمکی.",
    "institutional.work.technicalTitle": "توسعه",
    "institutional.work.technicalBody": "رفع خطا، تقویت آزمون‌ها یا بهبود معماری با حفظ جدایی ماژول‌ها و داده‌ها.",
    "institutional.work.action": "مشاهده راهنمای مشارکت",
    "institutional.work.actionMeta": "مخزن عمومی نصب محلی، کنترل‌های کیفیت و اصول لازم پیش از ارسال پیشنهاد را توضیح می‌دهد.",

    "institutional.dino.eyebrow": "شفافیت محصول",
    "institutional.dino.title": "دینو چگونه کار می‌کند؟",
    "institutional.dino.introduction": "دینو یک همراه زمینه‌محور و local-first است: فقط صفحهٔ جاری را می‌شناسد، چند کمک مرتبط را انتخاب می‌کند و قابلیت‌های آزمایشی را شفاف از امکانات فعال جدا نگه می‌دارد.",
    "institutional.dino.tryAction": "امتحان کردن دینو",
    "institutional.dino.contextTitle": "زمینه‌ای محدود",
    "institutional.dino.contextBody": "دینو نوع صفحه، شناسهٔ عمومی درس و کارتی را که به او نشان می‌دهید می‌شناسد. پاسخ‌ها، توکن‌ها و داده‌های حساس از این زمینه حذف می‌شوند.",
    "institutional.dino.localTitle": "تصمیم‌گیری محلی",
    "institutional.dino.localBody": "مرورگر کمک‌ها را با قواعد محلی رتبه‌بندی می‌کند و هرگز بیش از سه پیشنهاد نشان نمی‌دهد. برای این انتخاب، زمینهٔ آموزشی به سرور ما ارسال نمی‌شود.",
    "institutional.dino.voiceTitle": "خواندن متناسب",
    "institutional.dino.voiceBody": "زبان متن به‌صورت خودکار تشخیص داده می‌شود، واژهٔ جاری برجسته می‌شود و دینو طبیعی‌ترین صدای موجود را ترجیح می‌دهد. کارکرد آفلاین به دستگاه و مرورگر بستگی دارد.",
    "institutional.dino.avatarLabel": "دینو در حال فکر کردن",
    "institutional.dino.nowEyebrow": "عملکرد کنونی",
    "institutional.dino.nowTitle": "امروز مفید، برای فردا قابل گسترش",
    "institutional.dino.nowBody": "امروز دینو یک کارت را می‌خواند، یک بخش دستور زبان را از محتوای اصلی آن توضیح می‌دهد و هنگام تمرین یک راهنمایی راهبردی ارائه می‌کند. همین قرارداد بعداً می‌تواند بدون بازطراحی رابط، یک مدل هوش مصنوعی محلی را بپذیرد.",
    "institutional.dino.availableTitle": "در دسترس",
    "institutional.dino.availableBody": "خواندن هدفمند، واژه یا عبارت با یک لمس، بهترین صدای موجود، توضیح محلی محدود و راهنمایی مرحله‌ای بدون پاسخ مورد انتظار.",
    "institutional.dino.plannedTitle": "برنامه‌ریزی‌شده اما غیرفعال",
    "institutional.dino.plannedBody": "بازنویسی مولد، توضیح خطاها، گفتگو، میکروفون و دوربین تا زمانی که موتور محلی قابل‌اعتماد و مجوزهای لازم متصل نشوند با برچسب «به‌زودی» می‌مانند.",
    "institutional.dino.privacyTitle": "local-first دقیقاً یعنی چه؟",
    "institutional.dino.privacyBody": "انتخاب کمک‌ها و زمینهٔ دینو در برنامه باقی می‌ماند. تولید صدا را مرورگر فراهم می‌کند و ممکن است به خدمات سیستم وابسته باشد. میکروفون و دوربین بدون اقدام و اجازهٔ صریح شما هرگز شروع نمی‌شوند.",

    "auth.eyebrow": "فضای من",
    "auth.title": "ورود با ایمیل",
    "auth.introduction": "یک پیوند امن برای ورود از طریق ایمیل دریافت کنید؛ نیازی به ساختن یا به‌خاطر سپردن گذرواژه نیست.",
    "auth.emailLabel": "نشانی ایمیل",
    "auth.emailPlaceholder": "you@example.com",
    "auth.requestCode": "دریافت پیوند ورود",
    "auth.codeTitle": "ایمیل خود را بررسی کنید",
    "auth.codeSent": "پیوند امن ارسال‌شده به {email} را باز کنید. اگر ایمیل یک کد ۶ رقمی دارد، می‌توانید آن را اینجا نیز وارد کنید.",
    "auth.codeLabel": "کد ۶ رقمی (در صورت نمایش)",
    "auth.verifyCode": "تأیید کد",
    "auth.changeEmail": "تغییر ایمیل",
    "auth.resend": "ارسال دوباره ایمیل",
    "auth.resendIn": "ارسال دوباره تا {seconds} ثانیه",
    "auth.invalidEmail": "یک نشانی ایمیل معتبر وارد کنید.",
    "auth.invalidCode": "کد باید دقیقاً ۶ رقم داشته باشد.",
    "auth.genericError": "ورود تأیید نشد. کد را بررسی کنید یا چند لحظه دیگر دوباره تلاش کنید.",
    "auth.unavailableTitle": "ورود موقتاً در دسترس نیست",
    "auth.unavailableBody": "بخش آموزشی همچنان در دسترس است، اما سرویس حساب در این محیط تنظیم نشده است.",
    "auth.privacy": "ایمیل شما فقط برای امنیت حساب دینو استفاده می‌شود. پیوند یا کد ورود خود را هرگز برای شخص دیگری نفرستید.",

    "profile.eyebrow": "فضای من",
    "profile.title": "پروفایل من",
    "profile.createIntroduction": "هویتی بسازید که در دینو همراه شما باشد.",
    "profile.editIntroduction": "نام، آواتار و شیوه نمایش خود در دینو را تغییر دهید.",
    "profile.email": "حساب متصل",
    "profile.displayName": "نام نمایشی",
    "profile.displayNameHint": "بین ۲ تا ۴۰ نویسه. ایمیل شما هرگز به‌صورت عمومی نمایش داده نمی‌شود.",
    "profile.avatar": "آواتار",
    "profile.avatar.green": "دینوی سبز",
    "profile.avatar.blue": "دینوی آبی",
    "profile.avatar.coral": "دینوی مرجانی",
    "profile.saurusSuffix": "افزودن «Saurus» به نام من",
    "profile.saurusSuffixHint": "نمونه: Mina به Mina Saurus تبدیل می‌شود. هر زمان بخواهید می‌توانید این پسوند را غیرفعال کنید.",
    "profile.saurusRequiredTitle": "Saurus تو منتظر است",
    "profile.saurusRequiredBody": "به سه پرسش پاسخ بده، پیشنهاد دینو را ببین و سپس همراهت را انتخاب کن.",
    "profile.saurusRequiredAction": "کشف Saurus من ←",
    "profile.preview": "پیش‌نمایش",
    "profile.previewPlaceholder": "نام Saurus شما",
    "profile.create": "ساخت پروفایل",
    "profile.save": "ذخیره",
    "profile.saved": "پروفایل ذخیره شد.",
    "profile.invalid": "نام باید بین ۲ تا ۴۰ نویسه داشته باشد.",
    "profile.saveError": "در حال حاضر ذخیره پروفایل ممکن نیست.",
    "profile.unavailableTitle": "پروفایل موقتاً در دسترس نیست",
    "profile.unavailableBody": "سرویس حساب در دسترس نیست، اما درس‌ها همچنان قابل استفاده‌اند.",
    "profile.signOut": "خروج از حساب",
    "profile.signOutError": "در حال حاضر خروج از حساب ممکن نیست.",
    "profile.credits": "اعتبارهای من",
    "profile.creditsUnavailable": "اعتبارها در دسترس نیستند",
    "profile.openShop": "باز کردن فروشگاه",
    "profile.rewardsTitle": "پاداش‌های دریافت‌شده",
    "profile.rewardsDescription": "آخرین فعالیت‌هایی که برای آن‌ها پاداش گرفته‌اید.",
    "profile.rewardsEmpty": "یک درس سفر را کامل کنید یا در یک بازی برنده شوید تا نخستین اعتبارهای خود را بگیرید.",
    "profile.rewardsUnavailable": "تاریخچه پاداش‌ها موقتاً در دسترس نیست.",
    "profile.rewardFallback": "فعالیت آموزشی",
    "profile.rewardHangman": "بازی حدس کلمه · سطح {level}",
    "profile.rewardWordSearch": "جدول جستجوی واژه · سطح {level}",
    "profile.rewardCrossword": "جدول کلمات متقاطع · سطح {level}",
    "profile.rewardCredits": "+{count} اعتبار",
    "profile.progressSyncTitle": "پیشرفت در چند دستگاه",
    "profile.progressSyncReady": "درس‌های دستور زبان و سفر شما با این حساب همگام هستند.",
    "profile.progressSyncing": "در حال همگام‌سازی پیشرفت شما…",
    "profile.progressSyncError": "پیشرفت روی این دستگاه می‌ماند و در شروع بعدی یا ادامه یادگیری دوباره همگام می‌شود.",
    "profile.learningProgressTitle": "پیشرفت من",
    "profile.learningProgressDescription": "نمایی کلی از مسیرهای کامل‌شده و پاداش‌های بازی شما.",
    "profile.learningProgressGrammar": "دستور زبان",
    "profile.learningProgressTravel": "سفر",
    "profile.learningProgressGames": "بازی‌ها",
    "profile.learningProgressLessons": "{completed} / {total} درس کامل‌شده",
    "profile.learningProgressRewards": "{completed} / {total} پاداش دریافت‌شده",
    "profile.learningProgressUnavailable": "خلاصه پیشرفت موقتاً در دسترس نیست.",
    "profile.exerciseHistoryTitle": "تمرین‌های من",
    "profile.exerciseHistoryDescription": "آخرین امتیازهای شما روی این دستگاه می‌مانند و با حسابتان همگام می‌شوند.",
    "profile.exerciseHistoryEmpty": "یک تمرین دستور زبان، سفر یا واژگان را کامل کنید تا تاریخچه نمایش داده شود.",
    "profile.exerciseAttempts": "تلاش‌ها",
    "profile.exerciseAverage": "میانگین",
    "profile.exerciseBest": "بهترین",
    "profile.exerciseGrammar": "دستور زبان · {id}",
    "profile.exerciseTravel": "سفر · {id}",
    "profile.exerciseVocabulary": "واژگان · سطح {level}",
    "profile.exerciseScore": "{correct}/{total} · {percentage}٪",
    "profile.exerciseSyncError": "این امتیازها روی دستگاه ذخیره می‌مانند و همگام‌سازی خودکار دوباره انجام می‌شود.",
    "profile.dailyPracticeTitle": "ریتم من",
    "profile.dailyGoalReached": "هدف امروز کامل شد، آفرین!",
    "profile.dailyGoalRemaining": "{count} تمرین دیگر تا هدف امروز باقی مانده است.",
    "profile.dailyGoalStart": "برای شروع روزتان یک تمرین انجام دهید.",
    "profile.dailyStreak": "🔥 {count} روز",
    "profile.dailyGoalProgress": "هدف روزانه",
    "profile.dailyDayLabel": "{day}: {count} تمرین",
    "profile.dailyPracticeAction": "شروع جلسه ←",

    "saurus.eyebrow": "ماجراجویی من",
    "saurus.title": "تو کدام Saurus هستی؟",
    "saurus.introduction": "با سه پرسش همراه یادگیری خود را پیدا کن. دینو یک پیشنهاد می‌دهد و انتخاب نهایی با توست.",
    "saurus.quiz.progress": "پرسش {current} از {total}",
    "saurus.quiz.progressLabel": "پیشرفت آزمون Saurus",
    "saurus.quiz.question.newLesson": "وقتی یک درس تازه را شروع می‌کنی، کدام حالت بیشتر شبیه توست؟",
    "saurus.quiz.question.challenge": "در برابر یک تمرین دشوار، ترجیح می‌دهی چگونه پیش بروی؟",
    "saurus.quiz.question.session": "کدام جلسه یادگیری بیشتر به تو انگیزه می‌دهد؟",
    "saurus.quiz.answer.explore": "سریع کاوش کنم و چند راه را امتحان کنم",
    "saurus.quiz.answer.persist": "آرام تکرار کنم تا کاملاً مسلط شوم",
    "saurus.quiz.answer.understand": "پیش از ادامه دلیل موضوع را بفهمم",
    "saurus.quiz.answer.try": "فوراً شروع کنم و بعد روش را تنظیم کنم",
    "saurus.quiz.answer.steps": "گام‌به‌گام و بدون تسلیم شدن پیش بروم",
    "saurus.quiz.answer.connect": "نگاه کنم و میان ایده‌ها ارتباط بسازم",
    "saurus.quiz.answer.varied": "کوتاه، پرانرژی و سرشار از کشف",
    "saurus.quiz.answer.regular": "منظم، پیوسته و اطمینان‌بخش",
    "saurus.quiz.answer.deep": "کنجکاوانه، عمیق و همراه با توضیح",
    "saurus.velociraptor.name": "ولوسی‌رپتور کاوشگر",
    "saurus.velociraptor.trait": "سریع و جسور است و با آزمودن و کاوش یاد می‌گیرد.",
    "saurus.triceratops.name": "تریسراتوپس پرتلاش",
    "saurus.triceratops.trait": "استوار و منظم است و گام‌به‌گام بدون تسلیم شدن پیش می‌رود.",
    "saurus.brachiosaurus.name": "براکیوسور کنجکاو",
    "saurus.brachiosaurus.trait": "دقیق و کنجکاو است و دوست دارد ایده‌ها را بفهمد و به هم پیوند دهد.",
    "saurus.choice.recommendation": "پیشنهاد دینو",
    "saurus.choice.title": "همراهت را انتخاب کن",
    "saurus.choice.hint": "می‌توانی پیشنهاد را بپذیری یا Saurus مناسب خودت را انتخاب کنی. پس از آن گونه ثابت می‌ماند.",
    "saurus.choice.recommended": "پیشنهادشده",
    "saurus.choice.error": "ثبت انتخاب تأیید نشد. انتخابت در همین صفحه می‌ماند؛ کمی بعد دوباره تلاش کن.",
    "saurus.choice.restart": "آزمون دوباره",
    "saurus.choice.confirm": "تأیید Saurus من",
    "saurus.assigned.title": "Saurus تو آماده است!",
    "saurus.assigned.introduction": "گونه اکنون به پروفایل تو پیوند خورده است؛ ثابت می‌ماند و با فعالیت‌هایت رشد می‌کند.",
    "saurus.assigned.profile": "دیدن پروفایل من",
    "saurus.assigned.home": "ورود به دینو ←",
    "saurus.identity.label": "هویت Saurus",
    "saurus.identity.title": "Saurus من",
    "saurus.identity.visible": "در پروفایل تو دیده می‌شود",
    "saurus.phase.label": "مرحله · {phase}",
    "saurus.phase.hatchling": "تولد",
    "saurus.phase.explorer": "کاوش",
    "saurus.phase.guide": "راهنما",
    "saurus.phase.progress": "رشد Saurus",
    "saurus.phase.remaining": "{count} فعالیت دیگر",
    "saurus.phase.complete": "مرحله راهنما رسید: Saurus تو رشد فعلی خود را کامل کرده است.",
    "saurus.error.title": "Saurus موقتاً در دسترس نیست",
    "saurus.error.body": "پروفایل تو محفوظ است. کمی بعد برای ادامه آزمون بازگرد.",

    "archive.eyebrow": "فضای من",
    "archive.title": "آرشیو من",
    "archive.introduction": "درس‌های تمام‌شده و نتیجه تمرین‌های خود را همراه با پیوند مستقیم برای باز کردن دوباره پیدا کنید.",
    "archive.completedTitle": "درس‌های تمام‌شده",
    "archive.completedDescription": "کتابخانه محلی شما پس از ورود همراه حسابتان همگام می‌شود.",
    "archive.completedCount": "{count} درس",
    "archive.grammar": "دستور زبان",
    "archive.travel": "سفر",
    "archive.completedAt": "تمام‌شده در {date}",
    "archive.emptyTitle": "آرشیو شما آماده رشد است",
    "archive.emptyDescription": "یک درس دستور زبان یا سفر را کامل کنید تا اینجا نمایش داده شود.",
    "archive.startDaily": "شروع جلسه امروز ←",
    "archive.exercisesTitle": "تاریخچه تمرین‌ها",
    "archive.exercisesDescription": "آخرین نتیجه‌های دستور زبان، سفر و واژگان.",
    "archive.loadErrorTitle": "بارگذاری عنوان‌های آرشیو ممکن نیست",
    "archive.loadErrorDescription": "پیشرفت شما روی این دستگاه محفوظ است. برای پیوند دوباره درس‌ها تلاش کنید.",

    "rewards.available": "🎁 این درس را کامل کنید: +{count} اعتبار",
    "rewards.gameAvailable": "🏆 یک بازی در سطح {level} ببرید: +{count} اعتبار",
    "rewards.gameSignIn": "🏆 بازی را بردید؛ برای دریافت {count} اعتبار وارد شوید",
    "rewards.claiming": "🎁 اعتبارهای شما در حال ثبت است…",
    "rewards.awardedOne": "🎉 ۱ اعتبار دریافت شد",
    "rewards.awarded": "🎉 {count} اعتبار دریافت شد",
    "rewards.signIn": "🎁 درس کامل شد؛ برای دریافت {count} اعتبار وارد شوید",
    "rewards.claimError": "تأیید پاداش ممکن نشد.",

    "shop.eyebrow": "خدمات",
    "shop.title": "فروشگاه درس‌ها",
    "shop.introduction": "با اعتبارهای پروفایل خود درس‌های تازه را باز کنید. هر خرید برای همیشه در مجموعه شما باقی می‌ماند.",
    "shop.balance": "موجودی من",
    "shop.balanceUnavailable": "موجودی در دسترس نیست",
    "shop.credit": "{count} اعتبار",
    "shop.credits": "{count} اعتبار",
    "shop.catalogPrice": "فروشگاه · {price} اعتبار",
    "shop.loading": "در حال بارگذاری فروشگاه…",
    "shop.catalogTitle": "درس‌های موجود",
    "shop.catalogDescription": "پیش از افزودن درس به مجموعه، سطح و قیمت آن را بررسی کنید.",
    "shop.lesson": "درس",
    "shop.level": "سطح {level}",
    "shop.owned": "خریداری‌شده",
    "shop.openLesson": "باز کردن درس",
    "shop.buyPrice": "خرید · {price}",
    "shop.buying": "در حال خرید…",
    "shop.insufficientCredits": "اعتبار کافی نیست",
    "shop.signInTitle": "برای استفاده از اعتبارهای خود وارد شوید",
    "shop.signInBody": "اکنون می‌توانید درس‌ها را ببینید. ورود به حساب از موجودی و خریدهای شما محافظت می‌کند.",
    "shop.signIn": "ورود",
    "shop.signInToBuy": "ورود برای خرید",
    "shop.purchaseSuccess": "«{title}» به مجموعه شما افزوده شد.",
    "shop.purchaseError": "خرید تأیید نشد. پیش از تلاش دوباره، موجودی و درس‌های شما به‌روزرسانی می‌شوند.",
    "shop.unavailableTitle": "فروشگاه موقتاً در دسترس نیست",
    "shop.unavailableBody": "سرویس خرید در این محیط پیکربندی نشده است. درس‌هایی که از پیش در دسترس‌اند همچنان قابل استفاده هستند.",
    "shop.errorTitle": "بارگذاری فروشگاه ممکن نیست",
    "shop.errorBody": "موجودی شما تغییر نکرده است. کمی بعد دوباره مراجعه کنید.",
    "shop.emptyTitle": "فعلاً درسی برای فروش وجود ندارد",
    "shop.emptyBody": "درس‌های تازه به‌محض آماده‌شدن در اینجا نمایش داده می‌شوند.",
    "shop.lockedTitle": "این درس باید باز شود",
    "shop.lockedBody": "این درس را در فروشگاه پیدا کنید و با اعتبارهای خود به مجموعه‌تان بیفزایید.",
    "shop.lockedSignIn": "ورود برای باز کردن درس",

    "onboarding.chooseLanguage": "زبان خود را انتخاب کنید",
    "onboarding.french": "Français",
    "onboarding.persian": "فارسی",
    "onboarding.choosePath": "مسیر یادگیری خود را انتخاب کنید",
    "onboarding.general": "فرانسوی عمومی",
    "onboarding.travel": "فرانسوی در سفر",
    "onboarding.levelQuestion": "آیا می‌خواهید ابتدا تعیین سطح انجام دهید؟",
    "onboarding.startTest": "انجام تعیین سطح",
    "onboarding.later": "بعداً",
    "onboarding.dontKnow": "نمی‌دانم",
    "onboarding.finalResult": "نتیجه تعیین سطح",
    "onboarding.yourLevel": "سطح تقریبی شما",
    "onboarding.canModify": "بعداً هم می‌توانید آن را تغییر دهید.",
    "onboarding.acceptLevel": "قبول این سطح",
    "onboarding.changeLevel": "تغییر سطح",
    "onboarding.chooseYourLevel": "سطح خود را انتخاب کنید",

    "home.greeting": "سلام، ادامه بده!",
    "home.currentLevel": "سطح فعلی شما",
    "home.dailySessionOpen": "باز کردن جلسه امروز من",
    "home.dailySessionProgress": "{completed}/{total} امروز",
    "home.newsAdvice": "📰 اخبار و نکات",

    "exercise.defaultTitle": "تمرین",
    "exercise.unsupportedQuestion": "این نوع سؤال هنوز در رابط کاربری پشتیبانی نمی‌شود.",
    "exercise.correct": "آفرین!",
    "exercise.incorrect": "اشتباه!",
    "exercise.returnLesson": "بازگشت به درس",

    "grammar.level.A1": "مبتدی",
    "grammar.level.A2": "پایه",
    "grammar.level.B1": "متوسط",
    "grammar.level.B2": "پیشرفته",
    "grammar.level.C1": "مستقل",
    "grammar.level.C2": "تسلط کامل",
    "grammar.chooseLevel": "سطح دستور زبان خود را انتخاب کنید.",
    "grammar.levelMeta": "مشاهده درس‌ها",
    "grammar.recommended": "پیشنهاد دینو",
    "grammar.allLessons": "همه درس‌ها",
    "grammar.exercises": "تمرین‌ها",
    "grammar.lessonNotFound": "این درس پیدا نشد.",
    "grammar.sectionNotFound": "این بخش پیدا نشد.",
    "grammar.type.lesson": "درسنامه",
    "grammar.type.exercise": "تمرین",
    "grammar.type.quiz": "آزمون",
    "grammar.completedSuffix": " · تمام شده",
    "grammar.progress": "پیشرفت",
    "grammar.examples": "مثال‌ها",
    "grammar.status.completed": "تمام شده",
    "grammar.status.inProgress": "در حال مطالعه",
    "grammar.status.notStarted": "شروع نشده",

    "travel.catalogTitle": "سفر ({count} درس)",
    "travel.noLessons": "هیچ درسی پیدا نشد.",
    "travel.lessonNotFound": "درس پیدا نشد.",
    "travel.sectionsCount": "{count} بخش",
    "travel.type.vocab": "واژگان",
    "travel.type.tips": "نکات",
    "travel.type.lesson": "درسنامه",
    "travel.type.exercise": "تمرین",
    "travel.type.unknown": "بخش",
    "travel.exerciseOpensSeparately": "این تمرین در صفحه تمرین باز می‌شود.",
    "travel.unsupportedContent": "این نوع محتوا پشتیبانی نمی‌شود: {type}",
    "travel.tipFallback": "نکته {number}",

    "poll.weekly": "نظرسنجی هفته",
    "poll.subtitle": "نظر شما برای ما مهم است!",
    "poll.totalVotes": "مجموع آرا: {count}",
    "poll.changeVote": "تغییر رأی",

    "news.weekly": "خبر هفته",
    "news.journalTitle": "مجله",
    "news.journalSubtitle": "خبرها و فرهنگ فرانسه متناسب با سطح شما.",
    "news.journalEmpty": "در حال حاضر مقاله‌ای در دسترس نیست.",
    "news.readMore": "مشاهده کامل ←",
    "news.fullText": "متن کامل",
    "news.simpleText": "متن ساده",
    "news.simplifiedVersion": "نسخه ساده‌شده",
    "news.keyVocabulary": "واژگان کلیدی",
    "news.viewVocabularyPack": "مشاهده بسته واژگان",
    "news.grammarPoints": "نکات گرامری",
    "news.viewGrammarLesson": "مشاهده درس گرامر",
    "news.grammarLevel": "⚠️ این نکته برای سطح {level} است.",
    "news.advancedGrammarHidden": "💡 نکات گرامری این متن برای سطح فعلی شما پیشرفته است و پنهان شده‌اند.",
    "news.sources": "منابع",
    "news.notFound": "این خبر پیدا نشد.",

    "search.title": "جستجو در سایت",
    "search.close": "بستن جستجو",
    "search.placeholder": "کلمه یا عبارت...",
    "search.minCharacters": "حداقل ۲ حرف تایپ کنید...",
    "search.loading": "در حال جستجو...",
    "search.noResults": "نتیجه‌ای پیدا نشد.",
    "search.error": "خطا در جستجو",
    "search.vocabulary": "واژگان",
    "search.grammar": "گرامر",
    "search.news": "اخبار",

    "practice.eyebrow": "تمرین",
    "practice.title": "بازی‌ها و تمرین‌ها",
    "practice.introduction": "یک بازی، سطح و موضوع انتخاب کنید. هر بازی نشانی دارد که می‌توانید نگه دارید یا به اشتراک بگذارید.",
    "practice.gamesTitle": "بازی‌های واژگان",
    "practice.gamesDescription": "سه روش سرگرم‌کننده برای به خاطر سپردن واژه‌های فرانسوی.",
    "practice.chooseLevel": "انتخاب سطح",
    "practice.playLevel": "بازی در سطح {level}",
    "practice.chooseTheme": "موضوع بازی خود را انتخاب کنید.",
    "practice.chooseAnotherTheme": "انتخاب موضوع دیگر",
    "practice.noThemes": "برای این سطح موضوعی در دسترس نیست.",
    "practice.invalidRoute": "این بازی یا سطح وجود ندارد.",
    "practice.exercisesTitle": "مسیرهای تمرینی",
    "practice.exercisesDescription": "فعالیت‌های موجود در درس‌ها و بسته‌ها را پیدا کنید.",
    "practice.grammarDescription": "یک قاعده را بفهمید و سپس آن را تمرین کنید.",
    "practice.vocabularyDescription": "با فلش‌کارت، داستان و آزمون مرور کنید.",
    "practice.travelDescription": "در موقعیت‌های واقعی سفر تمرین کنید.",

    "daily.eyebrow": "جلسه روزانه",
    "daily.title": "جلسه امروز من",
    "daily.introduction": "سه فعالیت شخصی‌سازی‌شده تا بدون جستجو بدانید امروز چه چیزی تمرین کنید.",
    "daily.cardDescription": "سه اولویت متناسب با نتیجه‌ها و سطح خود را پیدا کنید.",
    "daily.level": "سطح {level}",
    "daily.tasksTitle": "سه مرحله امروز",
    "daily.tasksDescription": "ابتدا دشواری‌های اخیر و سپس پیشنهادهای متناسب با سطح شما نمایش داده می‌شوند.",
    "daily.reason.score": "آخرین نتیجه: {percentage}٪",
    "daily.reason.mistake": "{count} پاسخ برای تمرین دوباره",
    "daily.reason.weakWord": "{count} واژه دشوار برای مرور",
    "daily.reason.discovery": "پیشنهاد متناسب با سطح شما",
    "daily.openTask": "شروع ←",
    "daily.loadErrorTitle": "آماده‌سازی جلسه ممکن نیست",
    "daily.loadErrorDescription": "پیشرفت شما محفوظ است. برای بارگذاری دوباره فعالیت‌ها تلاش کنید.",
    "daily.emptyTitle": "امروز فعالیتی در دسترس نیست",
    "daily.emptyDescription": "به‌محض آماده‌شدن محتوای سازگار، فعالیت‌های بعدی اینجا نمایش داده می‌شوند.",
    "daily.completeTitle": "هدف امروز کامل شد!",
    "daily.completeDescription": "سه تمرین امروز تمام شده‌اند و زنجیره و نتیجه‌های شما به‌روز هستند.",
    "daily.openReview": "مشاهده مرورها ←",

    "review.eyebrow": "تمرین شخصی‌سازی‌شده",
    "review.title": "مرورهای من",
    "review.cardDescription": "اشتباه‌ها و واژه‌هایی را که دشوار علامت زده‌اید دوباره تمرین کنید.",
    "review.introduction": "دینو دشواری‌های ثبت‌شده شما را به اقدام‌های بعدی روشن تبدیل می‌کند.",
    "review.localNotice": "بدون ورود به حساب، اشتباه‌ها، واژه‌های دشوار و نتیجه‌های شما روی همین دستگاه می‌مانند.",
    "review.syncReady": "مرورها و نتیجه‌های شما با این حساب همگام شده و در دستگاه‌های دیگر نیز در دسترس هستند.",
    "review.syncing": "در حال همگام‌سازی مرورها…",
    "review.syncError": "مرورها روی این دستگاه در دسترس می‌مانند و در شروع یا یادگیری بعدی دوباره همگام می‌شوند.",
    "review.mistakeCount": "{count} اشتباه",
    "review.wordCount": "{count} واژه دشوار",
    "review.scoreCount": "{count} امتیاز برای مرور",
    "review.emptyTitle": "فعلاً چیزی برای مرور نیست",
    "review.emptyDescription": "درس‌ها را ادامه دهید و واژه‌های دشوار را علامت بزنید تا خودکار اینجا نمایش داده شوند.",
    "review.openPractice": "انتخاب فعالیت",
    "review.mistakesTitle": "درس‌هایی برای تکرار",
    "review.mistakesDescription": "درس‌ها بر اساس تازه‌ترین اشتباه شما مرتب شده‌اند.",
    "review.lessonMistakes": "{count} پاسخ برای تمرین دوباره",
    "review.retryLesson": "تکرار درس",
    "review.markReviewed": "مرور شد",
    "review.noMistakes": "پاسخ نادرستی ثبت نشده است.",
    "review.weakWordsTitle": "واژه‌های دشوار",
    "review.weakWordsDescription": "مستقیماً یک جلسه فلش‌کارت هدفمند را شروع کنید.",
    "review.reviewWords": "مرور {count} واژه ←",
    "review.noWeakWords": "واژه دشواری ثبت نشده است.",
    "review.scoresTitle": "تمرین‌هایی برای تکرار",
    "review.scoresDescription": "آخرین نتیجه هر تمرین زیر ۸۰٪، از کمترین امتیاز تا بیشترین، اینجا نمایش داده می‌شود.",
    "review.scoreAttempt": "آخرین تلاش در {date}",
    "review.scoreResult": "{correct}/{total} · {percentage}%",
    "review.scoreProgress": "نتیجه برای {title}",
    "review.retryExercise": "تکرار تمرین ←",
    "review.noLowScores": "هیچ تمرینی پایین‌تر از هدف ۸۰٪ نیست.",

    "vocab.title": "📖 واژگان",
    "vocab.chooseLevel": "سطح خود را انتخاب کنید",
    "vocab.levelMeta": "فلش‌کارت و داستان",
    "vocab.chooseCategory": "یک دسته انتخاب کنید",
    "vocab.packSoon": "این پک به زودی اضافه می‌شود.",
    "vocab.flashcards": "فلش‌کارت‌ها",
    "vocab.simpleStory": "داستان ساده",
    "vocab.simpleStoryMeta": "متن کوتاه با جای خالی",
    "vocab.literaryStory": "داستان ادبی",
    "vocab.literaryStoryMeta": "متن بلندتر با جای خالی",
    "vocab.quiz": "تمرین",
    "vocab.quizMeta": "آزمون کوتاه",
    "vocab.weakWords": "مرور کلمات ضعیف",
    "vocab.noWeakWords": "کلمه‌ای برای مرور نیست! 🎉",
    "vocab.cardHint": "👆 برای دیدن معنی و مثال، روی کارت بزن",
    "vocab.unknown": "بلد نیستم",
    "vocab.known": "بلدم",
    "vocab.weakWordsNote": "کلماتی که بلد نیستی، در پایان مرور می‌شوند و برای جلسه بعد ذخیره می‌شوند.",
    "vocab.unknownCount": "{count} کلمه را بلد نبودی",
    "vocab.reviewNow": "حالا وقت مرور است!",
    "vocab.review": "مرور کن",
    "vocab.toggleTranslation": "نمایش / مخفی ترجمه",
    "vocab.keywords": "کلمات کلیدی",
    "vocab.comprehension": "درک مطلب",
    "vocab.fillBlanks": "جاهای خالی را با کلمه درست پر کن:",
    "vocab.checkAnswers": "بررسی جواب‌ها",
    "vocab.storyTranslation": "ترجمه داستان",
    "vocab.exerciseSoon": "به زودی",
    "vocab.game.hangman": "بازی حدس کلمه",
    "vocab.game.hangmanMeta": "کلمه را حرف‌به‌حرف حدس بزنید",
    "vocab.game.hangmanInstructions": "پیش از تمام شدن هفت فرصت، حروف درست را پیدا کنید.",
    "vocab.game.wordSearch": "جدول جستجوی کلمات",
    "vocab.game.wordSearchMeta": "واژه‌های موضوع را در جدول پیدا کنید",
    "vocab.game.wordSearchInstructions": "ابتدا حرف اول و سپس حرف آخر کلمه را در هر جهت لمس کنید.",
    "vocab.game.crossword": "جدول کلمات متقاطع",
    "vocab.game.crosswordMeta": "جدول را با کمک ترجمه‌ها کامل کنید",
    "vocab.game.crosswordInstructions": "با استفاده از راهنماهای فارسی، واژه‌های فرانسوی را وارد کنید.",
    "vocab.game.newRound": "بازی جدید",
    "vocab.game.clue": "راهنما",
    "vocab.game.remaining": "{count} اشتباه دیگر مجاز است",
    "vocab.game.wrongLetters": "حروف نادرست",
    "vocab.game.won": "آفرین! کلمه «{word}» بود.",
    "vocab.game.lost": "بازی تمام شد. کلمه «{word}» بود.",
    "vocab.game.wordsToFind": "کلمات برای پیدا کردن",
    "vocab.game.foundCount": "{found} از {total} کلمه پیدا شده",
    "vocab.game.selectEnd": "اکنون آخرین حرف را انتخاب کنید.",
    "vocab.game.wordFound": "«{word}» پیدا شد!",
    "vocab.game.wordSearchMiss": "این خط با هیچ کلمه باقی‌مانده‌ای مطابقت ندارد.",
    "vocab.game.wordSearchCompleted": "جدول کامل شد، آفرین!",
    "vocab.game.across": "افقی",
    "vocab.game.down": "عمودی",
    "vocab.game.check": "بررسی جدول",
    "vocab.game.crosswordCell": "ردیف {row}، ستون {column}",
    "vocab.game.crosswordCompleted": "جدول کلمات متقاطع کامل شد، آفرین!",
    "vocab.game.crosswordRetry": "برخی حروف نادرست هستند یا وارد نشده‌اند.",
    "vocab.game.unavailable": "این بسته هنوز واژه‌های سازگار کافی برای این بازی ندارد."
};
